export default {
	danger: '#e53935',
	green: '#136f40',
	yellow: '#e7b032',
	swal: '#0a0b0d',
	orange: '#FB8C00',
	blue: '#2c4cff',
	orangeTable: '#FFCC80',
	greenTable: '#8BC34A',
	redTable: '#EF5350',
	blueTable: '#42A5F5',
	white: '#fff',
	green_light: '#46fca5',
	gray: '#3f3f3f',
	chartFree: '#2b4bfd',
	chartPremium: '#2bff6d',
	gray7: '#3c4748'
}